import { runbookContactConstants } from "../constants/runbookContact.constants";

const initialState = {
  loading: false,
  loadingCreate: false,
  loadingUpdate: false,
  loadingDelete: false,
  paginatedResult: {
    data: [],
    totalCount: 0,
    pageSize: 10,
    currentPage: 0,
  },
  contact: null,
  createSuccess: false,
  updateSuccess: false,
  deleteSuccess: false,
  error: false,
  createError: false,
  updateError: false,
  deleteError: false,
};

export function runbookContact(state = initialState, action) {
  switch (action.type) {
    case runbookContactConstants.GET_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case runbookContactConstants.GET_SUCCESS:
      return {
        ...state,
        loading: false,
        paginatedResult: action.payload,
      };
    case runbookContactConstants.GET_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    case runbookContactConstants.GET_BY_ID_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        contact: null,
      };
    case runbookContactConstants.GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        contact: action.payload,
      };
    case runbookContactConstants.GET_BY_ID_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    case runbookContactConstants.CREATE_REQUEST:
      return {
        ...state,
        loadingCreate: true,
        createSuccess: false,
        createError: false,
      };
    case runbookContactConstants.CREATE_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        createSuccess: true,
      };
    case runbookContactConstants.CREATE_FAILURE:
      return {
        ...state,
        loadingCreate: false,
        createError: true,
      };

    case runbookContactConstants.UPDATE_REQUEST:
      return {
        ...state,
        loadingUpdate: true,
        updateSuccess: false,
        updateError: false,
      };
    case runbookContactConstants.UPDATE_SUCCESS:
      return {
        ...state,
        loadingUpdate: false,
        updateSuccess: true,
      };
    case runbookContactConstants.UPDATE_FAILURE:
      return {
        ...state,
        loadingUpdate: false,
        updateError: true,
      };

    case runbookContactConstants.DELETE_REQUEST:
      return {
        ...state,
        loadingDelete: true,
        deleteSuccess: false,
        deleteError: false,
      };
    case runbookContactConstants.DELETE_SUCCESS:
      return {
        ...state,
        loadingDelete: false,
        deleteSuccess: true,
      };
    case runbookContactConstants.DELETE_FAILURE:
      return {
        ...state,
        loadingDelete: false,
        deleteError: true,
      };

    default:
      return state;
  }
}
